import { render } from "./ListarReceitasGerais.vue?vue&type=template&id=d819587c&scoped=true"
import script from "./ListarReceitasGerais.vue?vue&type=script&lang=js"
export * from "./ListarReceitasGerais.vue?vue&type=script&lang=js"

import "./ListarReceitasGerais.vue?vue&type=style&index=0&id=d819587c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d819587c"]])

export default __exports__